import { render, staticRenderFns } from "./TCIPremium.vue?vue&type=template&id=bf84bbc8&"
import script from "./TCIPremium.vue?vue&type=script&lang=js&"
export * from "./TCIPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports